import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import {BiTrash} from "react-icons/bi";
import {client} from "../../dataProvider";
import {useRefresh} from "react-admin";



export function DeleteReconciliationFile({file_id}: {file_id: string}){
    const [open, setOpen] = React.useState(false);
    const refetch = useRefresh()
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        client(`reconciliation_file/${file_id}`, {method: "DELETE"})
            .then(() => {
                refetch();
                handleClose();
            })
            .catch((error) => console.error("Failed to delete reconciliation file:", error))
    }

    return(
        <div>
            <Button onClick={handleClickOpen}>
                <BiTrash size={20} color="red"/>
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">Sei sicuro di voler eliminare il file?</DialogTitle>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Chiudi
                    </Button>
                    <Button onClick={handleDelete} color="primary" autoFocus>
                        Elimina
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}